import { render, staticRenderFns } from "./WeightSvg.vue?vue&type=template&id=bccf7cf2&"
import script from "./WeightSvg.vue?vue&type=script&lang=js&"
export * from "./WeightSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports